import React, { Component } from 'react';
import styles from './ResultComponent.module.scss';
import Icon from '@ant-design/icons';
import { ReactComponent as ArrowLeftSvg } from '../../../../../resources/images/arrow-left.svg';
import CustomContext from '../../../../../context/CustomContext';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button, Empty, FormInstance, List } from 'antd';
import { EntityWithStatus, Project, ProjectMember } from '../../../../../model/entities';

class ResultComponent extends Component<Props> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;
    formRef = React.createRef<FormInstance>();

    /** METHODS **/

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        return (
            <>
                {this.renderFailures()}
                {this.renderSuccesses()}
                {this.renderEmpty()}
                {this.renderButtons()}
            </>
        );
    };

    renderFailures = (): React.ReactElement | undefined => {
        const { result, projects, intl } = this.props;
        const failures = result.filter((r) => r.status.type !== 'OK');
        if (failures.length > 0) {
            return (
                <List
                    header={
                        <h2>
                            <FormattedMessage id="projectMembers.import.steps.3.failure" />
                        </h2>
                    }
                    dataSource={failures}
                    renderItem={(failure, index) => {
                        const projectMember = failure.entity;
                        const email = projectMember.email || '...';
                        const project = projects.find((p) => p.id === projectMember.project?.id)?.name || '...';
                        return (
                            <List.Item key={index}>
                                <List.Item.Meta title={email} description={project} />
                                <span className={styles.error}>
                                    {failure.status.error
                                        ? intl.formatMessage({ id: failure.status.error })
                                        : failure.status.message}
                                </span>
                            </List.Item>
                        );
                    }}
                    className={styles.failure}
                />
            );
        }
    };

    renderSuccesses = (): React.ReactElement | undefined => {
        const { result, projects } = this.props;
        const successes = result.filter((r) => r.status.type === 'OK');
        if (successes.length > 0) {
            return (
                <List
                    header={
                        <h2>
                            <FormattedMessage id="projectMembers.import.steps.3.success" />
                        </h2>
                    }
                    dataSource={successes}
                    renderItem={(success, index) => {
                        const projectMember = success.entity;
                        const email = projectMember.email || '...';
                        const project = projects.find((p) => p.id === projectMember.project?.id)?.name;
                        return (
                            <List.Item key={index}>
                                <List.Item.Meta title={email} description={project} />
                            </List.Item>
                        );
                    }}
                    className={styles.success}
                />
            );
        }
    };

    renderEmpty = (): React.ReactElement | undefined => {
        const { result } = this.props;
        if (result.length === 0) {
            return <Empty className={styles.empty} />;
        }
    };

    renderButtons = (): React.ReactElement | undefined => {
        const { hubId, projects } = this.props;
        const projectIdsAsParam = projects.map((project) => 'projectId=' + project.id).join('&');

        return (
            <div className={styles.buttons}>
                <Link to={`/setup/project-members?hubId=${hubId}&${projectIdsAsParam}`}>
                    <Button type="primary" size="large" icon={<Icon component={ArrowLeftSvg} />}>
                        <FormattedMessage id="projectMembers.import.steps.3.back" tagName="span" />
                    </Button>
                </Link>
            </div>
        );
    };

    render() {
        return this.renderContent();
    }
}
export default injectIntl(ResultComponent);

interface Props extends WrappedComponentProps {
    hubId: string;
    projects: Project[];
    result: EntityWithStatus<ProjectMember>[];
}
